/* eslint-disable prettier/prettier */
export default {
  B_STATISTICS_AVG_RATE: 'Average Booking rate',
  B_STATISTICS_AVG_RATE_TIPS: 'Average Booking rate = Booking time of Hot Desks/Opening time of Hot Desks',
  B_STATISTICS_PEAK_RATE: 'Peak Booking rate',
  B_STATISTICS_PEAK_RATE_TIPS: 'The maximum of the Average Booking rate per hour from 0-23 hours per day',
  B_STATISTICS_SINGLE_AVG_RATE: 'Average Booking time',
  B_STATISTICS_SINGLE_AVG_RATE_TIPS: 'Average Booking time for a single Desk Booking',

  B_STATISTICS_BOOK_COUNT_AND_DESK: 'Number of users and bookable Desks',
  B_STATISTICS_BOOK_COUNT_AND_DESK_TIPS:
    'Average number of users and bookable Desks at specific hour on multiple days during the selected date',
  B_STATISTICS_AVG_BOOK_DESK_COUNT: 'Average number of bookable Desks',
  B_STATISTICS_AVG_BOOK_COUNT: 'Average number of users',

  B_STATISTICS_DAY_RATE: 'Daily Booking rate',
  B_STATISTICS_DAY_RATE_TIPS: 'Daily Average Booking rate and Daily Peak Booking rate during the selected date',
  B_STATISTICS_AVG_LINE: 'Average Line',
  B_STATISTICS_PEAK_LINE: 'Peak Line',

  B_STATISTICS_HOURS_RATE: 'Hourly booking rate',
  B_STATISTICS_HOURS_RATE_TIPS: 'Average Booking rate at specific hour on multiple days during the selected date',

  B_STATISTICS_RATE_HEAT_MAP: 'Booking rate heat distribution',
  B_STATISTICS_RATE_HEAT_MAP_TIPS:
    'Booking rate of each Desk and its popularity on the floor during the selected date.',
  B_STATISTICS_MAP_FIX_DESK: 'Fixed Desk currently',
  B_STATISTICS_MAP_NO_LICENSE: 'Disable currently',
  B_STATISTICS_MAP_DISABLED: 'Unauthorized currently',

  B_STATISTICS_SINGLE_HOURS_RANGE: 'Single Booking length distribution',
  B_STATISTICS_SINGLE_HOURS_RANGE_TIPS:
    'Percentage of the duration of all booking records in each time interval during the selected date.',
  B_STATISTICS_HOUR: 'hour(s)',

  B_STATISTICS_SHARED_DESK_RANGE: 'Hot Desks Booking Charts',
  B_STATISTICS_SHARED_DESK_RANGE_TIPS:
    // eslint-disable-next-line max-len
    'Ranking of individual Desks during the selected date; when selecting positive order, the top five Desks with the highest Booking rate are displayed; when selecting Booking order, the top five Desks with the lowest Booking rate are displayed',
  B_STATISTICS_BOOKING_RATE: 'Booking rate',

  B_STATISTICS_BOOKING_OVERVIEW_EXCEL: 'All forms of Booking Overview',
  B_STATISTICS_BOOKING_OVERVIEW_IMAGE: 'All pictures of Booking Overview',

  B_STATISTICS_BUILDING: 'Building',

  B_STATISTICS_QUERY_TIPS: 'Please wait patiently while we try to find out...',
  B_STATISTICS_DEPARTMENT_PERSONNUMBER: 'Number of departments',
  B_STATISTICS_DESK_NUMBER: 'Number of desks',
  B_STATISTICS_DEPARTMENT_NUMBER: 'Number used by the Department',
  B_STATISTICS_OTHER_DERPATMENT_USE_NUMBER: 'Number of external door',
  B_STATISTICS_DESK_UNUSECOUNT: 'Number of unused desks',
  B_STATISTICS_USE_RATE: 'Utilization rate',
  B_STATISTICS_UNUSE_RATE: 'Idle rate',
  B_STATISTICS_POSITION_UNUSE_RATE: 'Vacancy rate',
  B_STATISTICS_DERPARTMENT_REAL_DATA: 'Real time data of departments',
  B_STATISTICS_POSITION: 'Location',
  B_STATISTICS_BIND_USING_COUNT: 'Station bound (used)',
  B_STATISTICS_BIND_UNASSIGNED_COUNT: 'Unassigned (idle) desk',
  B_STATISTICS_HOT_RESERVE_COUNT: 'Reserved desk',
  B_STATISTICS_POSITION_REAL_DATA: 'Position latitude Station real time data',
  B_STATISTICS_SIGNED_DESK: 'Signed in (used) desk',
  B_STATISTICS_BOOKABLE_DESK: 'Bookable (free) desk',
  B_STATISTICS_HOT_DESK_REVERSE: 'Shared desk booking',
  B_STATISTICS_FIX_DESK_USE: 'Usage of fixed desk',
  B_STATISTICS_DAY_REVERSE: 'Daily booking usage',
  B_STATISTICS_DEPARTMENT_USE_RANKING: 'Top 5 departments of shared desk reservation',
  B_STATISTICS_REVERSE_NUMBER: 'Number of bookings',
  B_STATISTICS_USE_NUMBER: 'Usage times',
  B_STATISTICS_DEPARTMENT_USE_NUMBER: 'Number of departments in use',
  B_STATISTICS_USE_RATE_TIPS: 'Total number of desks used (summary of shared and fixed desks) / total number of desk',
  B_STATISTICS_UNUSE_RATE_TIPS: 'Number of unused desks / number of desks in this department',
  B_STATISTICS_POSITION_UNUSE_RATE_TIPS: 'Total number of idle desks / total number of desks',
  B_STATISTICS_DEPARTMENT_USE_NUMBER_TIPS:
    'The number of users on the fixed position assigned to the Department is the number of personnel in the Department',
  B_STATISTICS_DEPARTMENT_NUMBER_TIPS:
    'The number of desks (assigned to the Department) activated by the personnel of the Department',
  B_STATISTICS_OTHER_DERPATMENT_USE_NUMBER_TIPS:
    // eslint-disable-next-line max-len
    'The number of desks (assigned to the Department) that are not bound and activated by the personnel of the Department',
}
